import { DriverActions, DriverActionType } from './actions';
import { DriversTableColumn, getDriversTableColumns, setDriversTableColumns } from './tableColumns';

export interface DriverState {
  tableColumns: Array<DriversTableColumn>;
}

export const getInitialState = (): DriverState => ({
  tableColumns: getDriversTableColumns(),
});

export const DriverReducer = (state: DriverState, action: DriverActions): DriverState => {
  switch (action.type) {
    case DriverActionType.SET_DRIVERS_TABLE_COLUMNS:
      setDriversTableColumns(action.payload);
      return {
        ...state,
        tableColumns: action.payload,
      };
    default:
      return state;
  }
};
